import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { useState } from "react";

interface Props {
  items: string[];
  checked?: string[];
  disabled: boolean;
  rowOrientation?: boolean;
  minWidth?: number;
  maxWidth?: number;
  onChange: (items: string[]) => void;
}

const CheckboxButtons: React.FC<Props> = ({items, checked, disabled, rowOrientation = false, minWidth = 140, maxWidth = 140, onChange}) => {
  const [checkedItems, setCheckedItems] = useState(checked || []);

  const handleChecked = (value: string) => {
    const currentIndex = checkedItems.findIndex(item => item === value);
    let newChecked: string[] = [];
    if (currentIndex === -1) {
      newChecked = [...checkedItems, value];
    } else {
      newChecked = checkedItems.filter(item => item !== value);
    }

    setCheckedItems(newChecked);

    onChange(newChecked);
  }

  return (
    <FormGroup row={rowOrientation}>
      {
        items.map(item => (
          <FormControlLabel
            key={item}
            control={<Checkbox
              checked={checkedItems.indexOf(item) !== -1}
              onClick={() => handleChecked(item)}
            />}
            label={<Typography variant="body2" color="textSecondary">{item}</Typography>}
            style={{ minWidth: minWidth, maxWidth: maxWidth }}
            disabled={disabled}
          />
        ))
      }
    </FormGroup>
  )
}

const ComplexCheckboxButtons: React.FC<Props> = ({items, checked, disabled, rowOrientation = false, minWidth = 140, maxWidth = 140, onChange}) => {
  const [checkedItems, setCheckedItems] = useState(checked || []);

  const handleChecked = (value: string) => {
    const currentIndex = checkedItems.findIndex(item => item === value);
    let newChecked: string[] = [];
    if (currentIndex === -1) {
      newChecked = [...checkedItems, value];
    } else {
      newChecked = checkedItems.filter(item => item !== value);
    }

    setCheckedItems(newChecked);

    onChange(newChecked);
  }

  return (
    <FormGroup row={rowOrientation}>
      {
        items.map(item => (
          <FormControlLabel
            key={item.split('|')[1]}
            control={<Checkbox
              checked={checkedItems.indexOf(item.split('|')[1]) !== -1}
              onClick={() => handleChecked(item.split('|')[1])}
            />}
            label={<Typography variant="body2" color="textSecondary">{item.split('|')[0]}</Typography>}
            style={{ minWidth: minWidth, maxWidth: maxWidth }}
            disabled={disabled}
          />
        ))
      }
    </FormGroup>
  )
}

export { CheckboxButtons, ComplexCheckboxButtons };
